import { Map as ImmutableMap } from 'immutable';
import { createAction as reduxActionsCreator } from 'redux-actions';

import { actionHelpers } from 'app-components/flux/core';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import type { scheduledTransactionsTypes } from 'app-components/flux/scheduled-transactions';

export const DIALOG_TYPE = 'BILL_PRESENTMENT_DIALOG';

// Resource actions

export const billerCredentialsSubmit = actionHelpers.createAction('BILLER_CREDENTIALS_SUBMIT');
export const billerCredentialsResponse = actionHelpers.createAction('BILLER_CREDENTIALS_RESPONSE');

export interface BillPresentmentProps {
  series: scheduledTransactionsTypes.ScheduledTransactionType;
  initiator?: string;
}

// Dialog Actions

export const doBillPresentment = reduxActionsCreator(
  rootUiActions.createDialog.toString(),
  (series: scheduledTransactionsTypes.ScheduledTransactionType, initiator?: string) =>
    rootUiTypes.mkRootUiData({
      type: DIALOG_TYPE,
      id: `BPS-${series?.id}`,
      props: ImmutableMap({
        series,
        initiator,
      }),
    }),
  (_payload, meta) => meta,
);
